export const DEPARTMENT_DATA = [
  {
    key: 'CU',
    value: 'C-Suite',
    children: [
      { key: 'CU000', value: 'Executive' },
      { key: 'CU001', value: 'Founder' },
      { key: 'CU002', value: 'Finance Executive' },
      { key: 'CU003', value: 'HR Executive' },
      { key: 'CU004', value: 'Health Executive' },
      { key: 'CU005', value: 'Legal Executive' },
      { key: 'CU006', value: 'Marketing Executive' },
      { key: 'CU007', value: 'Operations Executive' },
      { key: 'CU008', value: 'Product & Engineering Executive' },
      { key: 'CU009', value: 'Sales Executive' },
    ],
  },
  {
    key: 'FN',
    value: 'Finance',
    children: [
      { key: 'FN000', value: 'Accounting' },
      { key: 'FN001', value: 'Financial Planning & Analysis' },
      { key: 'FN002', value: 'Financial Reporting' },
      { key: 'FN003', value: 'Financial Strategy' },
      { key: 'FN004', value: 'Internal Audit & Control' },
      { key: 'FN005', value: 'Investment Management' },
      { key: 'FN006', value: 'Investor Relations' },
      { key: 'FN007', value: 'Risk' },
      { key: 'FN008', value: 'Tax' },
    ],
  },
  {
    key: 'HR',
    value: 'Hr',
    children: [
      { key: 'HR000', value: 'Compensation & Benefits' },
      { key: 'HR001', value: 'Diversity & Inclusion' },
      { key: 'HR002', value: 'Employee & Labor Relations' },
      { key: 'HR003', value: 'Learning & Development' },
      { key: 'HR004', value: 'Recruiting' },
      { key: 'HR005', value: 'Talent Management' },
    ],
  },
  {
    key: 'HL',
    value: 'Health',
    children: [
      { key: 'HL000', value: 'Clinical Operations' },
      { key: 'HL001', value: 'Dental' },
      { key: 'HL002', value: 'Doctor' },
      { key: 'HL003', value: 'Fitness' },
      { key: 'HL004', value: 'Medical Administration' },
      { key: 'HL005', value: 'Medical Education & Training' },
      { key: 'HL006', value: 'Medical Research' },
      { key: 'HL007', value: 'Nursing' },
      { key: 'HL008', value: 'Therapy' },
      { key: 'HL009', value: 'Wellness' },
    ],
  },
  {
    key: 'LG',
    value: 'Legal',
    children: [
      { key: 'LG000', value: 'Compliance' },
      { key: 'LG001', value: 'Contracts' },
      { key: 'LG002', value: 'Corporate Secretary' },
      { key: 'LG003', value: 'Legal Counsel' },
      { key: 'LG004', value: 'Litigation' },
      { key: 'LG005', value: 'Privacy' },
    ],
  },
  {
    key: 'MR',
    value: 'Marketing',
    children: [
      { key: 'MR000', value: 'Advertising' },
      { key: 'MR001', value: 'Brand Management' },
      { key: 'MR002', value: 'Content Marketing' },
      { key: 'MR003', value: 'Customer Experience' },
      { key: 'MR004', value: 'Demand Generation' },
      { key: 'MR005', value: 'Digital Marketing' },
      { key: 'MR006', value: 'Event Marketing' },
      { key: 'MR007', value: 'Product Marketing' },
      { key: 'MR008', value: 'Public Relations (PR)' },
      { key: 'MR009', value: 'Search Engine Optimization (SEO)' },
      { key: 'MR010', value: 'Social Media Marketing' },
    ],
  },
  {
    key: 'OP',
    value: 'Operations',
    children: [
      { key: 'OP000', value: 'Call Center' },
      { key: 'OP001', value: 'Corporate Strategy' },
      { key: 'OP002', value: 'Customer Service / Support' },
      { key: 'OP003', value: 'Facilities Management' },
      { key: 'OP004', value: 'Logistics' },
      { key: 'OP005', value: 'Manufacturing' },
      { key: 'OP006', value: 'Office Operations' },
      { key: 'OP007', value: 'Project Management' },
      { key: 'OP008', value: 'Quality Management' },
      { key: 'OP009', value: 'Real Estate' },
      { key: 'OP010', value: 'Supply Chain' },
    ],
  },
  {
    key: 'PR',
    value: 'Product & Engineering',
    children: [
      { key: 'PR000', value: 'Artificial Intelligence / Machine Learning' },
      { key: 'PR001', value: 'Devops' },
      { key: 'PR002', value: 'Data Science' },
      { key: 'PR003', value: 'Digital Transformation' },
      { key: 'PR004', value: 'Electrical Engineering' },
      { key: 'PR005', value: 'Graphic Design' },
      { key: 'PR006', value: 'Information Security' },
      { key: 'PR007', value: 'Information Technology' },
      { key: 'PR008', value: 'Mechanical Engineering' },
      { key: 'PR009', value: 'Network Operations' },
      { key: 'PR010', value: 'Product Design' },
      { key: 'PR011', value: 'Product Management' },
      { key: 'PR012', value: 'Project Engineering' },
      { key: 'PR013', value: 'Quality Assurance' },
      { key: 'PR014', value: 'Software Development' },
      { key: 'PR015', value: 'Systems Administration' },
      { key: 'PR016', value: 'Web Design' },
      { key: 'PR017', value: 'Web Development' },
    ],
  },
  {
    key: 'SL',
    value: 'Sales',
    children: [
      { key: 'SL000', value: 'Account Management' },
      { key: 'SL001', value: 'Business Development' },
      { key: 'SL002', value: 'Channel Sales' },
      { key: 'SL003', value: 'Customer Success' },
      { key: 'SL004', value: 'Inside Sales' },
      { key: 'SL005', value: 'Sales Enablement' },
      { key: 'SL006', value: 'Sales Operations' },
    ],
  },
  {
    key: 'EC',
    value: 'Education',
    children: [
      { key: 'EC000', value: 'Administration' },
      { key: 'EC001', value: 'Professor' },
      { key: 'EC002', value: 'Researcher' },
      { key: 'EC003', value: 'Teacher' },
    ],
  },
];

export const LOCATION_DATA = [
  {
    key: 'AF',
    value: 'Africa',
    children: [
      { key: 'AF000', value: 'Algeria' },
      { key: 'AF001', value: 'Angola' },
      { key: 'AF002', value: 'Benin' },
      { key: 'AF003', value: 'Botswana' },
      { key: 'AF004', value: 'Burkina Faso' },
      { key: 'AF005', value: 'Burundi' },
      { key: 'AF006', value: 'Cameroon' },
      { key: 'AF007', value: 'Cape Verde' },
      { key: 'AF008', value: 'Central African Republic' },
      { key: 'AF009', value: 'Chad' },
      { key: 'AF010', value: 'Comoros' },
      { key: 'AF011', value: 'Congo (DRC)' },
      { key: 'AF012', value: 'Congo (Republic)' },
      { key: 'AF013', value: 'Djibouti' },
      { key: 'AF014', value: 'Egypt' },
      { key: 'AF015', value: 'Equatorial Guinea' },
      { key: 'AF016', value: 'Eritrea' },
      { key: 'AF017', value: 'Ethiopia' },
      { key: 'AF018', value: 'Gabon' },
      { key: 'AF019', value: 'Gambia' },
      { key: 'AF020', value: 'Ghana' },
      { key: 'AF021', value: 'Guinea' },
      { key: 'AF022', value: 'Guinea-Bissau' },
      { key: 'AF023', value: 'Kenya' },
      { key: 'AF024', value: 'Lesotho' },
      { key: 'AF025', value: 'Liberia' },
      { key: 'AF026', value: 'Libya' },
      { key: 'AF027', value: 'Madagascar' },
      { key: 'AF028', value: 'Malawi' },
      { key: 'AF029', value: 'Mali' },
      { key: 'AF030', value: 'Mauritania' },
      { key: 'AF031', value: 'Mauritius' },
      { key: 'AF032', value: 'Morocco' },
      { key: 'AF033', value: 'Mozambique' },
      { key: 'AF034', value: 'Namibia' },
      { key: 'AF035', value: 'Niger' },
      { key: 'AF036', value: 'Nigeria' },
      { key: 'AF037', value: 'Rwanda' },
      { key: 'AF038', value: 'Sao Tome and Principe' },
      { key: 'AF039', value: 'Senegal' },
      { key: 'AF040', value: 'Seychelles' },
      { key: 'AF041', value: 'Sierra Leone' },
      { key: 'AF042', value: 'Somalia' },
      { key: 'AF043', value: 'South Africa' },
      { key: 'AF044', value: 'Sudan' },
      { key: 'AF045', value: 'Swaziland' },
      { key: 'AF046', value: 'Tanzania' },
      { key: 'AF047', value: 'Togo' },
      { key: 'AF048', value: 'Tunisia' },
      { key: 'AF049', value: 'Uganda' },
      { key: 'AF050', value: 'Zambia' },
      { key: 'AF051', value: 'Zimbabwe' },
    ],
  },
  {
    key: 'AS',
    value: 'Asia',
    children: [
      { key: 'AS000', value: 'Afghanistan' },
      { key: 'AS001', value: 'Armenia' },
      { key: 'AS002', value: 'Azerbaijan' },
      { key: 'AS003', value: 'Bahrain' },
      { key: 'AS004', value: 'Bangladesh' },
      { key: 'AS005', value: 'Bhutan' },
      { key: 'AS006', value: 'Brunei Darussalam' },
      { key: 'AS007', value: 'Cambodia' },
      { key: 'AS008', value: 'China' },
      { key: 'AS009', value: 'Georgia (C)' },
      { key: 'AS010', value: 'India' },
      { key: 'AS011', value: 'Indonesia' },
      { key: 'AS012', value: 'Iran' },
      { key: 'AS013', value: 'Israel' },
      { key: 'AS014', value: 'Japan' },
      { key: 'AS015', value: 'Jordan' },
      { key: 'AS016', value: 'Kazakhstan' },
      { key: 'AS017', value: 'Kuwait' },
      { key: 'AS018', value: 'Kyrgyzstan' },
      { key: 'AS019', value: 'Laos' },
      { key: 'AS020', value: 'Lebanon' },
      { key: 'AS021', value: 'Malaysia' },
      { key: 'AS022', value: 'Maldives' },
      { key: 'AS023', value: 'Mongolia' },
      { key: 'AS024', value: 'Myanmar' },
      { key: 'AS025', value: 'Nepal' },
      { key: 'AS026', value: 'North Korea' },
      { key: 'AS027', value: 'Oman' },
      { key: 'AS028', value: 'Pakistan' },
      { key: 'AS029', value: 'Philippines' },
      { key: 'AS030', value: 'Qatar' },
      { key: 'AS031', value: 'Saudi Arabia' },
      { key: 'AS032', value: 'Singapore' },
      { key: 'AS033', value: 'South Korea' },
      { key: 'AS034', value: 'Sri Lanka' },
      { key: 'AS035', value: 'Syria' },
      { key: 'AS036', value: 'Taiwan' },
      { key: 'AS037', value: 'Tajikistan' },
      { key: 'AS038', value: 'Thailand' },
      { key: 'AS039', value: 'Turkey' },
      { key: 'AS040', value: 'Turkmenistan' },
      { key: 'AS041', value: 'United Arab Emirates' },
      { key: 'AS042', value: 'Uzbekistan' },
      { key: 'AS043', value: 'Vietnam' },
      { key: 'AS044', value: 'Yemen' },
    ],
  },
  {
    key: 'CM',
    value: 'CAN > Metro Areas',
    children: [
      { key: 'CM000', value: 'AB > Calgary Area' },
      { key: 'CM001', value: 'AB > Edmonton Area' },
      { key: 'CM002', value: 'BC > Abbotsford Area' },
      { key: 'CM003', value: 'BC > Kelowna Area' },
      { key: 'CM004', value: 'BC > Vancouver Area' },
      { key: 'CM005', value: 'BC > Victoria Area' },
      { key: 'CM006', value: 'MB > Winnipeg Area' },
      { key: 'CM007', value: 'NB > Moncton Area' },
      { key: 'CM008', value: 'NB > St. John Area' },
      { key: 'CM009', value: 'NL > St. John Area' },
      { key: 'CM010', value: 'NS > Halifax Area' },
      { key: 'CM011', value: 'NT > Yellowknife Area' },
      { key: 'CM012', value: 'ON > Barrie Area' },
      { key: 'CM013', value: 'ON > Brantford Area' },
      { key: 'CM014', value: 'ON > Guelph Area' },
      { key: 'CM015', value: 'ON > Hamilton Area' },
      { key: 'CM016', value: 'ON > Kingston Area' },
      { key: 'CM017', value: 'ON > Kitchener Area' },
      { key: 'CM018', value: 'ON > London Area' },
      { key: 'CM019', value: 'ON > Ottawa Area' },
      { key: 'CM020', value: 'ON > Peterborough Area' },
      { key: 'CM021', value: 'ON > St. Catherines Area' },
      { key: 'CM022', value: 'ON > Sudbury Area' },
      { key: 'CM023', value: 'ON > Thunder Bay Area' },
      { key: 'CM024', value: 'ON > Toronto Area' },
      { key: 'CM025', value: 'ON > Windsor Area' },
      { key: 'CM026', value: 'PEI > Charlottetown Area' },
      { key: 'CM027', value: 'QC > Chicoutimi Area' },
      { key: 'CM028', value: 'QC > Montreal Area' },
      { key: 'CM029', value: 'QC > Quebec Area' },
      { key: 'CM030', value: 'QC > Sherbrooke Area' },
      { key: 'CM031', value: 'QC > Trois Rivieres Area' },
      { key: 'CM032', value: 'SK > Regina Area' },
      { key: 'CM033', value: 'SK > Saskatoon Area' },
    ],
  },
  {
    key: 'CP',
    value: 'CAN > Provinces',
    children: [
      { key: 'CP000', value: 'Alberta' },
      { key: 'CP001', value: 'British Columbia' },
      { key: 'CP002', value: 'Manitoba' },
      { key: 'CP003', value: 'New Brunswick' },
      { key: 'CP004', value: 'Newfoundland' },
      { key: 'CP005', value: 'Northwest Territories' },
      { key: 'CP006', value: 'Nova Scotia' },
      { key: 'CP007', value: 'Nunavut' },
      { key: 'CP008', value: 'Ontario' },
      { key: 'CP009', value: 'Prince Edward Island' },
      { key: 'CP010', value: 'Quebec' },
      { key: 'CP011', value: 'Saskatchewan' },
      { key: 'CP012', value: 'Yukon' },
    ],
  },
  {
    key: 'EU',
    value: 'Europe',
    children: [
      { key: 'EU000', value: 'Albania' },
      { key: 'EU001', value: 'Andorra' },
      { key: 'EU002', value: 'Austria' },
      { key: 'EU003', value: 'Belarus' },
      { key: 'EU004', value: 'Belgium' },
      { key: 'EU005', value: 'Bosnia Herzegovina' },
      { key: 'EU006', value: 'Bulgaria' },
      { key: 'EU007', value: 'Croatia' },
      { key: 'EU008', value: 'Cyprus' },
      { key: 'EU009', value: 'Czech Republic' },
      { key: 'EU010', value: 'Denmark' },
      { key: 'EU011', value: 'Estonia' },
      { key: 'EU012', value: 'Finland' },
      { key: 'EU013', value: 'France' },
      { key: 'EU014', value: 'Germany' },
      { key: 'EU015', value: 'Greece' },
      { key: 'EU016', value: 'Hungary' },
      { key: 'EU017', value: 'Iceland' },
      { key: 'EU018', value: 'Ireland' },
      { key: 'EU019', value: 'Italy' },
      { key: 'EU020', value: 'Latvia' },
      { key: 'EU021', value: 'Liechtenstein' },
      { key: 'EU022', value: 'Lithuania' },
      { key: 'EU023', value: 'Luxembourg' },
      { key: 'EU024', value: 'Macedonia (FYROM)' },
      { key: 'EU025', value: 'Malta' },
      { key: 'EU026', value: 'Moldova' },
      { key: 'EU027', value: 'Monaco' },
      { key: 'EU028', value: 'Netherlands' },
      { key: 'EU029', value: 'Norway' },
      { key: 'EU030', value: 'Poland' },
      { key: 'EU031', value: 'Portugal' },
      { key: 'EU032', value: 'Romania' },
      { key: 'EU033', value: 'Russia' },
      { key: 'EU034', value: 'San Marino' },
      { key: 'EU035', value: 'Slovakia' },
      { key: 'EU036', value: 'Slovenia' },
      { key: 'EU037', value: 'Spain' },
      { key: 'EU038', value: 'Sweden' },
      { key: 'EU039', value: 'Switzerland' },
      { key: 'EU040', value: 'Ukraine' },
      { key: 'EU041', value: 'United Kingdom' },
    ],
  },
  {
    key: 'NA',
    value: 'North America',
    children: [
      { key: 'NA000', value: 'Antigua and Barbuda' },
      { key: 'NA001', value: 'Bahamas' },
      { key: 'NA002', value: 'Barbados' },
      { key: 'NA003', value: 'Belize' },
      { key: 'NA004', value: 'Canada' },
      { key: 'NA005', value: 'Costa Rica' },
      { key: 'NA006', value: 'Cuba' },
      { key: 'NA007', value: 'Dominica' },
      { key: 'NA008', value: 'Dominican Republic' },
      { key: 'NA009', value: 'El Salvador' },
      { key: 'NA010', value: 'Grenada' },
      { key: 'NA011', value: 'Guatemala' },
      { key: 'NA012', value: 'Haiti' },
      { key: 'NA013', value: 'Honduras' },
      { key: 'NA014', value: 'Jamaica' },
      { key: 'NA015', value: 'Mexico' },
      { key: 'NA016', value: 'Nicaragua' },
      { key: 'NA017', value: 'Panama' },
      { key: 'NA018', value: 'Saint Kitts and Nevis' },
      { key: 'NA019', value: 'Saint Vincent and the Grenadines' },
      { key: 'NA020', value: 'Trinidad and Tobago' },
      { key: 'NA021', value: 'United States' },
    ],
  },
  {
    key: 'OC',
    value: 'Oceania',
    children: [
      { key: 'OC000', value: 'Australia' },
      { key: 'OC001', value: 'Cook Islands' },
      { key: 'OC002', value: 'Fiji' },
      { key: 'OC003', value: 'Kiribati' },
      { key: 'OC004', value: 'New Zealand' },
      { key: 'OC005', value: 'Papua New Guinea' },
      { key: 'OC006', value: 'Samoa' },
      { key: 'OC007', value: 'Solomon Islands' },
      { key: 'OC008', value: 'Timor-Leste' },
      { key: 'OC009', value: 'Tonga' },
      { key: 'OC010', value: 'Vanuatu' },
    ],
  },
  {
    key: 'SA',
    value: 'South America',
    children: [
      { key: 'SA000', value: 'Argentina' },
      { key: 'SA001', value: 'Bolivia' },
      { key: 'SA002', value: 'Brazil' },
      { key: 'SA003', value: 'Chile' },
      { key: 'SA004', value: 'Colombia' },
      { key: 'SA005', value: 'Ecuador' },
      { key: 'SA006', value: 'Guyana' },
      { key: 'SA007', value: 'Paraguay' },
      { key: 'SA008', value: 'Peru' },
      { key: 'SA009', value: 'Suriname' },
      { key: 'SA010', value: 'Uruguay' },
      { key: 'SA011', value: 'Venezuela' },
    ],
  },
  {
    key: 'UM',
    value: 'US > Metro Areas',
    children: [
      { key: 'UM000', value: 'TX > Abilene Area' },
      { key: 'UM001', value: 'TX > Amarillo Area' },
      { key: 'UM002', value: 'TX > Austin Area' },
      { key: 'UM003', value: 'TX > Beaumont Area' },
      { key: 'UM004', value: 'TX > Bryan Area' },
      { key: 'UM005', value: 'TX > Corpus Christi Area' },
      { key: 'UM006', value: 'TX > Dallas Area' },
      { key: 'UM007', value: 'TX > El Paso Area' },
      { key: 'UM008', value: 'TX > Harlingen Area' },
      { key: 'UM009', value: 'TX > Houston Area' },
      { key: 'UM010', value: 'TX > Laredo Area' },
      { key: 'UM011', value: 'TX > Lubbock Area' },
      { key: 'UM012', value: 'TX > Odessa Area' },
      { key: 'UM013', value: 'TX > San Angelo Area' },
      { key: 'UM014', value: 'TX > San Antonio Area' },
      { key: 'UM015', value: 'TX > Tyler Area' },
      { key: 'UM016', value: 'TX > Victoria Area' },
      { key: 'UM017', value: 'TX > Wichita Falls Area' },
      { key: 'UM018', value: 'UT > Salt Lake City Area' },
      { key: 'UM019', value: 'VA > Charlottesville Area' },
      { key: 'UM020', value: 'VA > Hampton Roads Area' },
      { key: 'UM021', value: 'VA > Harrisonburg Area' },
      { key: 'UM022', value: 'VA > Richmond Area' },
      { key: 'UM023', value: 'VA > Roanoke Area' },
      { key: 'UM024', value: 'VT > Burlington Area' },
      { key: 'UM025', value: 'WA > Seattle Area' },
      { key: 'UM026', value: 'WA > Spokane Area' },
      { key: 'UM027', value: 'WA > Tri Cities Area' },
      { key: 'UM028', value: 'WI > Green Bay Area' },
      { key: 'UM029', value: 'WI > La Crosse Area' },
      { key: 'UM030', value: 'WI > Madison Area' },
      { key: 'UM031', value: 'WI > Milwaukee Area' },
      { key: 'UM032', value: 'WI > Wausau Area' },
      { key: 'UM033', value: 'WV > Bluefield Area' },
      { key: 'UM034', value: 'WV > Charleston Area' },
      { key: 'UM035', value: 'WV > Clarksburg Area' },
      { key: 'UM036', value: 'WV > Parkersburg Area' },
      { key: 'UM037', value: 'WY > Casper Area' },
      { key: 'UM038', value: 'WY > Cheyenne Area' },
      { key: 'UM039', value: 'CA > Los Angeles Area' },
      { key: 'UM040', value: 'CA > Monterey Bay Area' },
      { key: 'UM041', value: 'CA > Palm Springs Area' },
      { key: 'UM042', value: 'CA > Sacramento Area' },
      { key: 'UM043', value: 'CA > San Diego Area' },
      { key: 'UM044', value: 'CA > San Francisco Area' },
      { key: 'UM045', value: 'CA > San Jose Area' },
      { key: 'UM046', value: 'CA > Santa Barbara Area' },
      { key: 'UM047', value: 'CO > Colorado Springs Area' },
      { key: 'UM048', value: 'CO > Denver Area' },
      { key: 'UM049', value: 'CO > Grand Junction Area' },
      { key: 'UM050', value: 'CT > Hartford Area' },
      { key: 'UM051', value: 'DC > Washington Area' },
      { key: 'UM052', value: 'FL > Fort Myers Area' },
      { key: 'UM053', value: 'FL > Gainesville Area' },
      { key: 'UM054', value: 'FL > Jacksonville Area' },
      { key: 'UM055', value: 'FL > Miami Area' },
      { key: 'UM056', value: 'FL > Orlando Area' },
      { key: 'UM057', value: 'FL > Panama City Area' },
      { key: 'UM058', value: 'FL > Tallahassee Area' },
      { key: 'UM059', value: 'FL > Tampa Bay Area' },
      { key: 'UM060', value: 'FL > West Palm Beach Area' },
      { key: 'UM061', value: 'GA > Albany Area' },
      { key: 'UM062', value: 'GA > Atlanta Area' },
      { key: 'UM063', value: 'GA > Augusta Area' },
      { key: 'UM064', value: 'GA > Columbus Area' },
      { key: 'UM065', value: 'GA > Macon Area' },
      { key: 'UM066', value: 'GA > Savannah Area' },
      { key: 'UM067', value: 'HI > Honolulu Area' },
      { key: 'UM068', value: 'IA > Cedar Rapids Area' },
      { key: 'UM069', value: 'IA > Davenport Area' },
      { key: 'UM070', value: 'IA > Des Moines Area' },
      { key: 'UM071', value: 'IA > Ottumwa Area' },
      { key: 'UM072', value: 'IA > Sioux City Area' },
      { key: 'UM073', value: 'ID > Boise City Area' },
      { key: 'UM074', value: 'ID > Idaho Falls Area' },
      { key: 'UM075', value: 'ID > Twin Falls Area' },
      { key: 'UM076', value: 'IL > Chicago Area' },
      { key: 'UM077', value: 'IL > Peoria Area' },
      { key: 'UM078', value: 'IL > Quincy Area' },
      { key: 'UM079', value: 'IL > Rockford Area' },
      { key: 'UM080', value: 'IL > Springfield Area' },
      { key: 'UM081', value: 'IN > Evansville Area' },
      { key: 'UM082', value: 'IN > Fort Wayne Area' },
      { key: 'UM083', value: 'IN > Indianapolis Area' },
      { key: 'UM084', value: 'IN > Lafayette Area' },
      { key: 'UM085', value: 'IN > South Bend Area' },
      { key: 'UM086', value: 'IN > Terre Haute Area' },
      { key: 'UM087', value: 'KS > Topeka Area' },
      { key: 'UM088', value: 'KS > Wichita Area' },
      { key: 'UM089', value: 'KY > Bowling Green Area' },
      { key: 'UM090', value: 'KY > Lexington Area' },
      { key: 'UM091', value: 'KY > Louisville Area' },
      { key: 'UM092', value: 'KY > Paducah Area' },
      { key: 'UM093', value: 'LA > Alexandria Area' },
      { key: 'UM094', value: 'LA > Baton Rouge Area' },
      { key: 'UM095', value: 'LA > Lafayette Area' },
      { key: 'UM096', value: 'LA > Lake Charles Area' },
      { key: 'UM097', value: 'LA > Monroe Area' },
      { key: 'UM098', value: 'LA > New Orleans Area' },
      { key: 'UM099', value: 'LA > Shreveport Area' },
      { key: 'UM100', value: 'MA > Boston Area' },
      { key: 'UM101', value: 'MA > Springfield Area' },
      { key: 'UM102', value: 'MD > Baltimore Area' },
      { key: 'UM103', value: 'MD > Salisbury Area' },
      { key: 'UM104', value: 'ME > Bangor Area' },
      { key: 'UM105', value: 'ME > Portland Area' },
      { key: 'UM106', value: 'ME > PresqueIsle Area' },
      { key: 'UM107', value: 'MI > Alpena Area' },
      { key: 'UM108', value: 'MI > Detroit Area' },
      { key: 'UM109', value: 'MI > Flint Area' },
      { key: 'UM110', value: 'MI > Grand Rapids Area' },
      { key: 'UM111', value: 'MI > Lansing Area' },
      { key: 'UM112', value: 'MI > Marquette Area' },
      { key: 'UM113', value: 'MI > Traverse City Area' },
      { key: 'UM114', value: 'MN > Duluth Area' },
      { key: 'UM115', value: 'MN > Mankato Area' },
      { key: 'UM116', value: 'MN > Minneapolis Area' },
      { key: 'UM117', value: 'MN > Rochester Area' },
      { key: 'UM118', value: 'MO > Jefferson City Area' },
      { key: 'UM119', value: 'MO > Joplin Area' },
      { key: 'UM120', value: 'MO > Kansas City Area' },
      { key: 'UM121', value: 'MO > Saint Joseph Area' },
      { key: 'UM122', value: 'MO > Saint Louis Area' },
      { key: 'UM123', value: 'MO > Springfield Area' },
      { key: 'UM124', value: 'MS > Biloxi Area' },
      { key: 'UM125', value: 'MS > Columbus Area' },
      { key: 'UM126', value: 'MS > Greenville Area' },
      { key: 'UM127', value: 'MS > Hattiesburg Area' },
      { key: 'UM128', value: 'MS > Jackson Area' },
      { key: 'UM129', value: 'MS > Meridian Area' },
      { key: 'UM130', value: 'MT > Billings Area' },
      { key: 'UM131', value: 'MT > Butte Area' },
      { key: 'UM132', value: 'MT > Glendive Area' },
      { key: 'UM133', value: 'MT > Great Falls Area' },
      { key: 'UM134', value: 'MT > Helena Area' },
      { key: 'UM135', value: 'MT > Missoula Area' },
      { key: 'UM136', value: 'NC > Charlotte Area' },
      { key: 'UM137', value: 'NC > Greenville Area' },
      { key: 'UM138', value: 'NC > Raleigh Area' },
      { key: 'UM139', value: 'NC > Wilmington Area' },
      { key: 'UM140', value: 'NC > Winston Salem Area' },
      { key: 'UM141', value: 'ND > Bismarck Area' },
      { key: 'UM142', value: 'ND > Fargo Area' },
      { key: 'UM143', value: 'NE > Lincoln Area' },
      { key: 'UM144', value: 'NE > North Platte Area' },
      { key: 'UM145', value: 'NE > Omaha Area' },
      { key: 'UM146', value: 'NM > Albuquerque Area' },
      { key: 'UM147', value: 'NV > Las Vegas Area' },
      { key: 'UM148', value: 'NV > Reno Area' },
      { key: 'UM149', value: 'NY > Albany Area' },
      { key: 'UM150', value: 'NY > Binghamton Area' },
      { key: 'UM151', value: 'NY > Buffalo Area' },
      { key: 'UM152', value: 'NY > Elmira Area' },
      { key: 'UM153', value: 'NY > New York Area' },
      { key: 'UM154', value: 'NY > Rochester Area' },
      { key: 'UM155', value: 'NY > Syracuse Area' },
      { key: 'UM156', value: 'NY > Utica Area' },
      { key: 'UM157', value: 'NY > Watertown Area' },
      { key: 'UM158', value: 'OH > Cincinnati Area' },
      { key: 'UM159', value: 'OH > Cleveland Area' },
      { key: 'UM160', value: 'OH > Columbus Area' },
      { key: 'UM161', value: 'OH > Dayton Area' },
      { key: 'UM162', value: 'OH > Lima Area' },
      { key: 'UM163', value: 'OH > Toledo Area' },
      { key: 'UM164', value: 'OH > Wheeling Area' },
      { key: 'UM165', value: 'OH > Youngstown Area' },
      { key: 'UM166', value: 'OH > Zanesville Area' },
      { key: 'UM167', value: 'OK > Ardmore Area' },
      { key: 'UM168', value: 'OK > Oklahoma City Area' },
      { key: 'UM169', value: 'OK > Tulsa Area' },
      { key: 'UM170', value: 'OR > Bend Area' },
      { key: 'UM171', value: 'OR > Eugene Area' },
      { key: 'UM172', value: 'OR > Medford Area' },
      { key: 'UM173', value: 'OR > Portland Area' },
      { key: 'UM174', value: 'PA > Erie Area' },
      { key: 'UM175', value: 'PA > Harrisburg Area' },
      { key: 'UM176', value: 'PA > Johnstown Area' },
      { key: 'UM177', value: 'PA > Philadelphia Area' },
      { key: 'UM178', value: 'PA > Pittsburgh Area' },
      { key: 'UM179', value: 'PA > Wilkes Barre Area' },
      { key: 'UM180', value: 'PR > Aguadilla Area' },
      { key: 'UM181', value: 'PR > Mayaguez Area' },
      { key: 'UM182', value: 'PR > Ponce Area' },
      { key: 'UM183', value: 'PR > San Juan Area' },
      { key: 'UM184', value: 'RI > Providence Area' },
      { key: 'UM185', value: 'SC > Charleston Area' },
      { key: 'UM186', value: 'SC > Columbia Area' },
      { key: 'UM187', value: 'SC > Florence Area' },
      { key: 'UM188', value: 'SC > Greenville Area' },
      { key: 'UM189', value: 'SD > Rapid City Area' },
      { key: 'UM190', value: 'SD > Sioux Falls Area' },
      { key: 'UM191', value: 'TN > Chattanooga Area' },
      { key: 'UM192', value: 'TN > Jackson Area' },
      { key: 'UM193', value: 'TN > Knoxville Area' },
      { key: 'UM194', value: 'TN > Memphis Area' },
      { key: 'UM195', value: 'TN > Nashville Area' },
      { key: 'UM196', value: 'TN > Tri Cities Area' },
      { key: 'UM197', value: 'TX > Abilene Area' },
      { key: 'UM198', value: 'TX > Amarillo Area' },
      { key: 'UM199', value: 'TX > Austin Area' },
      { key: 'UM200', value: 'TX > Beaumont Area' },
      { key: 'UM201', value: 'TX > Bryan Area' },
      { key: 'UM202', value: 'TX > Corpus Christi Area' },
      { key: 'UM203', value: 'TX > Dallas Area' },
      { key: 'UM204', value: 'TX > El Paso Area' },
      { key: 'UM205', value: 'TX > Harlingen Area' },
      { key: 'UM206', value: 'TX > Houston Area' },
      { key: 'UM207', value: 'TX > Laredo Area' },
      { key: 'UM208', value: 'TX > Lubbock Area' },
      { key: 'UM209', value: 'TX > Odessa Area' },
      { key: 'UM210', value: 'TX > San Angelo Area' },
      { key: 'UM211', value: 'TX > San Antonio Area' },
      { key: 'UM212', value: 'TX > Tyler Area' },
      { key: 'UM213', value: 'TX > Victoria Area' },
      { key: 'UM214', value: 'TX > Wichita Falls Area' },
      { key: 'UM215', value: 'UT > Salt Lake City Area' },
      { key: 'UM216', value: 'VA > Charlottesville Area' },
      { key: 'UM217', value: 'VA > Hampton Roads Area' },
      { key: 'UM218', value: 'VA > Harrisonburg Area' },
      { key: 'UM219', value: 'VA > Richmond Area' },
      { key: 'UM220', value: 'VA > Roanoke Area' },
      { key: 'UM221', value: 'VT > Burlington Area' },
      { key: 'UM222', value: 'WA > Seattle Area' },
      { key: 'UM223', value: 'WA > Spokane Area' },
      { key: 'UM224', value: 'WA > Tri Cities Area' },
      { key: 'UM225', value: 'WI > Green Bay Area' },
      { key: 'UM226', value: 'WI > La Crosse Area' },
      { key: 'UM227', value: 'WI > Madison Area' },
      { key: 'UM228', value: 'WI > Milwaukee Area' },
      { key: 'UM229', value: 'WI > Wausau Area' },
      { key: 'UM230', value: 'WV > Bluefield Area' },
      { key: 'UM231', value: 'WV > Charleston Area' },
      { key: 'UM232', value: 'WV > Clarksburg Area' },
      { key: 'UM233', value: 'WV > Parkersburg Area' },
      { key: 'UM234', value: 'WY > Casper Area' },
      { key: 'UM235', value: 'WY > Cheyenne Area' },
    ],
  },
  {
    key: 'US',
    value: 'US > States',
    children: [
      { key: 'US000', value: 'Alabama, US' },
      { key: 'US001', value: 'Alaska, US' },
      { key: 'US002', value: 'Arizona, US' },
      { key: 'US003', value: 'Arkansas, US' },
      { key: 'US004', value: 'California, US' },
      { key: 'US005', value: 'Colorado, US' },
      { key: 'US006', value: 'Connecticut, US' },
      { key: 'US007', value: 'Delaware, US' },
      { key: 'US008', value: 'Florida, US' },
      { key: 'US009', value: 'Georgia, US' },
      { key: 'US010', value: 'Hawaii, US' },
      { key: 'US011', value: 'Idaho, US' },
      { key: 'US012', value: 'Illinois, US' },
      { key: 'US013', value: 'Indiana, US' },
      { key: 'US014', value: 'Iowa, US' },
      { key: 'US015', value: 'Kansas, US' },
      { key: 'US016', value: 'Kentucky, US' },
      { key: 'US017', value: 'Louisiana, US' },
      { key: 'US018', value: 'Maine, US' },
      { key: 'US019', value: 'Maryland, US' },
      { key: 'US020', value: 'Massachusetts, US' },
      { key: 'US021', value: 'Michigan, US' },
      { key: 'US022', value: 'Minnesota, US' },
      { key: 'US023', value: 'Mississippi, US' },
      { key: 'US024', value: 'Missouri, US' },
      { key: 'US025', value: 'Montana, US' },
      { key: 'US026', value: 'Nebraska, US' },
      { key: 'US027', value: 'Nevada, US' },
      { key: 'US028', value: 'New Hampshire, US' },
      { key: 'US029', value: 'New Jersey, US' },
      { key: 'US030', value: 'New Mexico, US' },
      { key: 'US031', value: 'New York, US' },
      { key: 'US032', value: 'North Carolina, US' },
      { key: 'US033', value: 'North Dakota, US' },
      { key: 'US034', value: 'Ohio, US' },
      { key: 'US035', value: 'Oklahoma, US' },
      { key: 'US036', value: 'Oregon, US' },
      { key: 'US037', value: 'Pennsylvania, US' },
      { key: 'US038', value: 'Rhode Island, US' },
      { key: 'US039', value: 'South Carolina, US' },
      { key: 'US040', value: 'South Dakota, US' },
      { key: 'US041', value: 'Tennessee, US' },
      { key: 'US042', value: 'Texas, US' },
      { key: 'US043', value: 'Utah, US' },
      { key: 'US044', value: 'Vermont, US' },
      { key: 'US045', value: 'Virginia, US' },
      { key: 'US046', value: 'Washington, US' },
      { key: 'US047', value: 'West Virginia, US' },
      { key: 'US048', value: 'Wisconsin, US' },
      { key: 'US049', value: 'Wyoming, US' },
      { key: 'US050', value: 'District of Columbia' },
      { key: 'US051', value: 'American Samoa' },
      { key: 'US052', value: 'Canal Zone' },
      { key: 'US053', value: 'Guam' },
      { key: 'US054', value: 'Puerto Rico' },
      { key: 'US055', value: 'Virgin Islands' },
    ],
  },
];

export const INDUSTRY_DATA = [
  {
    key: 'AF',
    value: 'Agriculture & Fishing',
    children: [
      { key: 'AF000', value: 'Agriculture' },
      { key: 'AF001', value: 'Crops' },
      { key: 'AF002', value: 'Dairy' },
      { key: 'AF003', value: 'Farming Animals & Livestock' },
      { key: 'AF004', value: 'Fishery & Aquaculture' },
      { key: 'AF005', value: 'Ranching' },
    ],
  },
  {
    key: 'BS',
    value: 'Business Services',
    children: [
      { key: 'BS000', value: 'Accounting & Accounting Services' },
      { key: 'BS001', value: 'Auctions' },
      { key: 'BS002', value: 'Business Services - General' },
      { key: 'BS003', value: 'Call Centers & Business Centers' },
      { key: 'BS004', value: 'Commercial Printing' },
      { key: 'BS005', value: 'Design' },
      { key: 'BS006', value: 'Digital Accessibility Services' },
      { key: 'BS007', value: 'Engineering Services' },
      { key: 'BS008', value: 'Equipment Rental Services' },
      { key: 'BS009', value: 'Event Services' },
      { key: 'BS010', value: 'Executive Search Services' },
      { key: 'BS011', value: 'Facilities Management & Services' },
      { key: 'BS012', value: 'Food Service' },
      { key: 'BS013', value: 'Geography & Positioning' },
      { key: 'BS014', value: 'Human Resources & Staffing' },
      { key: 'BS015', value: 'Information Services' },
      { key: 'BS017', value: 'Janitorial Services' },
      { key: 'BS018', value: 'Management Consulting' },
      { key: 'BS019', value: 'Multimedia & Graphic Design' },
      { key: 'BS020', value: 'Office Administration' },
      { key: 'BS021', value: 'Outsourcing' },
      { key: 'BS022', value: 'Repair & Maintenance' },
      { key: 'BS023', value: 'Sales, Marketing & Advertising' },
      { key: 'BS024', value: 'Security & Investigations Products & Services' },
      { key: 'BS025', value: 'Translation & Localization' },
      { key: 'BS026', value: 'HR, Staffing, & Recruiting' },
      { key: 'BS027', value: 'Writing & Editing' },
    ],
  },
  {
    key: 'CNO',
    value: 'Community & Non-Profit Organizations',
    children: [
      {
        key: 'CNO000',
        value: 'Non-Profit & Charitable Organizations & Foundations',
      },
      { key: 'CNO001', value: 'Organizations - General' },
      { key: 'CNO002', value: 'Philanthropy' },
      {
        key: 'CNO003',
        value: 'Professional Organizations',
      },
      { key: 'CNO004', value: 'Program Development' },
      { key: 'CNO005', value: 'Religious Organizations' },
    ],
  },
  {
    key: 'CN',
    value: 'Construction',
    children: [
      { key: 'CN000', value: 'Architecture Engineering & Design' },
      { key: 'CN001', value: 'Building Construction' },
      { key: 'CN002', value: 'Building Equipment Contractors' },
      { key: 'CN003', value: 'Building Finishing Contractors' },
      { key: 'CN004', value: 'Building Structure and Exterior Contractors' },
      { key: 'CN005', value: 'Construction - General' },
      { key: 'CN006', value: 'Highway, Street, and Bridge Construction' },
      { key: 'CN007', value: 'Landscaping Services' },
      { key: 'CN008', value: 'Mechanical Engineering' },
      { key: 'CN009', value: 'Mechanical or Industrial Engineering' },
      { key: 'CN010', value: 'Nonresidential Building Construction' },
      { key: 'CN011', value: 'Residential Building Construction' },
      { key: 'CN012', value: 'Specialty Trade Contractors' },
      { key: 'CN013', value: 'Utility System Construction' },
    ],
  },
  {
    key: 'CS',
    value: 'Consumer Services',
    children: [
      { key: 'CS000', value: 'Car & Truck Rental' },
      { key: 'CS001', value: 'Caterers' },
      { key: 'CS002', value: 'Child Care' },
      { key: 'CS003', value: 'Consumer Services - General' },
      { key: 'CS004', value: 'Funeral Homes & Funeral Related Services' },
      { key: 'CS005', value: 'Hair Salons and Cosmetology' },
      { key: 'CS006', value: 'Health Wellness & Fitness' },
      { key: 'CS007', value: 'Household Services' },
      { key: 'CS008', value: 'Laundry & Dry Cleaning Services' },
      { key: 'CS009', value: 'Photography' },
      { key: 'CS010', value: 'Vehicle Repair and Maintenance' },
      { key: 'CS011', value: 'Veterinary Care' },
    ],
  },
  {
    key: 'ED',
    value: 'Education',
    children: [
      { key: 'ED000', value: 'Career Services' },
      { key: 'ED001', value: 'Colleges & Universities' },
      { key: 'ED002', value: 'E-learning' },
      { key: 'ED003', value: 'Education - General' },
      { key: 'ED004', value: 'Education Management' },
      { key: 'ED005', value: 'Fine Arts Schools' },
      { key: 'ED006', value: 'Higher Education' },
      { key: 'ED007', value: 'K-12 Schools' },
      { key: 'ED008', value: 'Professional Training & Coaching' },
      { key: 'ED009', value: 'Sports and Recreation Instruction' },
      { key: 'ED010', value: 'Training' },
    ],
  },
  {
    key: 'EU',
    value: 'Energy, Utilities & Waste Treatment',
    children: [
      { key: 'EU000', value: 'Electricity & Energy' },
      { key: 'EU001', value: 'Environmental Services' },
      { key: 'EU002', value: 'Nuclear' },
      { key: 'EU003', value: 'Oil & Gas Exploration & Services' },
      { key: 'EU004', value: 'Renewables & Environment' },
      { key: 'EU005', value: 'Solar Electric Power Generation' },
      { key: 'EU006', value: 'Utilities' },
      { key: 'EU007', value: 'Water Energy & Waste Treatment' },
      { key: 'EU008', value: 'Energy, Utilities & Waste Treatment - General' },
    ],
  },
  {
    key: 'FI',
    value: 'Finance',
    children: [
      { key: 'FI000', value: 'Banking' },
      { key: 'FI001', value: 'Collection Agencies' },
      { key: 'FI002', value: 'Credit Cards & Transaction Processing' },
      { key: 'FI003', value: 'Finance - General' },
      { key: 'FI004', value: 'Financial Services' },
      { key: 'FI005', value: 'Funds, Trusts and Estates' },
      { key: 'FI006', value: 'Holding Companies' },
      { key: 'FI007', value: 'Investment Advice' },
      { key: 'FI008', value: 'Investment Advice' },
      { key: 'FI009', value: 'Investment Banking' },
      { key: 'FI010', value: 'Loan Brokers' },
      { key: 'FI011', value: 'Securities and Commodity Exchanges' },
      { key: 'FI012', value: 'Venture Capital & Private Equity' },
    ],
  },
  {
    key: 'GV',
    value: 'Government & Public Services',
    children: [
      { key: 'GV000', value: 'Chamber of Commerce' },
      { key: 'GV001', value: 'Communities' },
      { key: 'GV002', value: 'Conservation Programs' },
      { key: 'GV003', value: 'Corrections Facilities' },
      { key: 'GV004', value: 'Fire Protection' },
      { key: 'GV005', value: 'Government - General' },
      { key: 'GV006', value: 'Health & Human Services' },
      { key: 'GV007', value: 'International Affairs' },
      { key: 'GV008', value: 'Law Enforcement' },
      { key: 'GV009', value: 'Military' },
      { key: 'GV010', value: 'Public Policy' },
      { key: 'GV011', value: 'Public Safety' },
      { key: 'GV012', value: 'Space Research and Technology' },
      { key: 'GV013', value: 'Cities Towns & Municipalities - General' },
    ],
  },
  {
    key: 'HC',
    value: 'Healthcare',
    children: [
      { key: 'HC000', value: 'Biotechnology' },
      { key: 'HC001', value: 'Chiropractors' },
      { key: 'HC002', value: 'Dentists' },
      { key: 'HC003', value: 'Drug Manufacturing & Research' },
      { key: 'HC004', value: 'Drug Stores & Pharmacies' },
      { key: 'HC005', value: 'Emergency and Relief Services' },
      { key: 'HC006', value: 'Emergency Medical Transportation & Services' },
      { key: 'HC007', value: 'Elder & Disabled Care' },
      { key: 'HC008', value: 'Healthcare - General' },
      { key: 'HC009', value: 'Home Health Care Services' },
      { key: 'HC010', value: 'Hospitals' },
      { key: 'HC011', value: 'Hospitals & Healthcare' },
      { key: 'HC012', value: 'Medical & Diagnostic Laboratories' },
      { key: 'HC013', value: 'Medical Practice' },
      { key: 'HC014', value: 'Medicine' },
      { key: 'HC015', value: 'Mental Health Care' },
      { key: 'HC016', value: 'Optometrists' },
      { key: 'HC017', value: 'Pharmaceuticals' },
      { key: 'HC018', value: 'Physical, Occupational and Speech Therapists' },
      { key: 'HC019', value: 'Public Health' },
    ],
  },
  {
    key: 'LHT',
    value: 'Leisure & Hospitality',
    children: [
      { key: 'LHT000', value: 'Amusement Parks Arcades & Attractions' },
      { key: 'LHT001', value: 'Entertainment' },
      { key: 'LHT002', value: 'Fine Arts' },
      { key: 'LHT003', value: 'Fitness & Dance Facilities' },
      { key: 'LHT004', value: 'Gambling & Casinos' },
      { key: 'LHT005', value: 'Gaming' },
      { key: 'LHT006', value: 'Hotels, Lodging & Resorts' },
      { key: 'LHT007', value: 'Leisure & Hospitality - General' },
      { key: 'LHT008', value: 'Leisure, Travel & Tourism' },
      { key: 'LHT009', value: 'Libraries' },
      { key: 'LHT010', value: 'Movie Theaters' },
      { key: 'LHT011', value: 'Museums & Art Galleries' },
      { key: 'LHT012', value: 'Performing Arts' },
      { key: 'LHT013', value: 'Recreation' },
      { key: 'LHT014', value: 'Restaurants' },
      { key: 'LHT015', value: 'Sports' },
      { key: 'LHT016', value: 'Zoos & National Parks' },
      { key: 'LHT017', value: 'Bars, Taverns, and Nightclubs' },
      { key: 'LHT018', value: 'Cultural - General' },
      { key: 'LHT019', value: 'Golf Courses and Country Clubs' },
      { key: 'LHT020', value: 'Hotels, Lodging, & Resorts' },
    ],
  },
  {
    key: 'IS',
    value: 'Insurance',
    children: [{ key: 'IS000', value: 'Insurance - General' }],
  },
  {
    key: 'LFLS',
    value: 'Law Firms & Legal Services',
    children: [
      { key: 'LFLS000', value: 'Courts of Law' },
      { key: 'LFLS001', value: 'Law Firms & Legal Services - General' },
    ],
  },
  {
    key: 'LCS',
    value: 'Logistics & Supply Chain',
    children: [
      { key: 'LCS000', value: 'Import & Export & Trade' },
      { key: 'LCS001', value: 'Logistics & Supply Chain - General' },
      { key: 'LCS002', value: 'Shipping' },
      { key: 'LCS003', value: 'Warehousing' },
      { key: 'LCS004', value: 'Wholesale' },
    ],
  },
  {
    key: 'MF',
    value: 'Manufacturing',
    children: [
      { key: 'MF000', value: 'Aerospace & Defense' },
      { key: 'MF001', value: 'Animal and Leather Products' },
      { key: 'MF002', value: 'Appliances' },
      { key: 'MF003', value: 'Audio and Video Equipment and Products' },
      { key: 'MF004', value: 'Automotive' },
      { key: 'MF005', value: 'Automotive Equipment' },
      { key: 'MF006', value: 'Boats & Submarines' },
      { key: 'MF007', value: 'Building Materials' },
      { key: 'MF008', value: 'Business Supplies & Equipment' },
      { key: 'MF009', value: 'Chemical Products' },
      { key: 'MF010', value: 'Cleaning Products' },
      {
        key: 'MF011',
        value: 'Commercial and Industrial Machinery Maintenance',
      },
      { key: 'MF012', value: 'Commercial Machinery' },
      { key: 'MF013', value: 'Computer Hardware' },
      { key: 'MF014', value: 'Consumer Electronics' },
      { key: 'MF015', value: 'Consumer Goods' },
      {
        key: 'MF016',
        value: 'Cosmetics & Personal Care Products',
      },
      { key: 'MF017', value: 'Electrical Equipment and Products' },
      { key: 'MF018', value: 'Electronics & Electronics Manufacturing' },
      { key: 'MF019', value: 'Energy Equipment and Products' },
      { key: 'MF020', value: 'Fabricated Metal Products' },
      { key: 'MF021', value: 'Food & Beverages' },
      { key: 'MF022', value: 'Food Production' },
      { key: 'MF023', value: 'Furniture' },
      { key: 'MF024', value: 'Glass & Concrete' },
      { key: 'MF025', value: 'Hand Power and Lawn-care Tools' },
      { key: 'MF026', value: 'Household Goods' },
      { key: 'MF027', value: 'Industrial Machinery Equipment & Automation' },
      { key: 'MF028', value: 'Lighting Equipment and Products' },
      { key: 'MF029', value: 'Lumber & Wood Production' },
      { key: 'MF030', value: 'Manufacturing - General' },
      { key: 'MF031', value: 'Maritime' },
      { key: 'MF032', value: 'Measurement & Testing Equipment' },
      { key: 'MF033', value: 'Medical Devices & Equipment' },
      { key: 'MF034', value: 'Metal Products' },
      { key: 'MF035', value: 'Miscellaneous Building Materials' },
      { key: 'MF037', value: 'Office Equipment and Products' },
      { key: 'MF039', value: 'Paper, Wood & Forest Products' },
      { key: 'MF040', value: 'Petrochemicals' },
      { key: 'MF041', value: 'Plastics and Rubber Products' },
      { key: 'MF042', value: 'Plastics & Packaging & Containers' },
      { key: 'MF043', value: 'Plumbing & HVAC Equipment' },
      { key: 'MF044', value: 'Power Conversion & Protection Equipment' },
      { key: 'MF045', value: 'Recyclable Materials' },
      { key: 'MF046', value: 'Renewable Energy Equipment and Products' },
      { key: 'MF047', value: 'Semiconductor & Semiconductor Equipment' },
      { key: 'MF048', value: 'Shipbuilding' },
      { key: 'MF049', value: 'Telecommunication Equipment' },
      { key: 'MF050', value: 'Test & Measurement Equipment' },
      { key: 'MF051', value: 'Textiles, Fashion and Apparel' },
      { key: 'MF052', value: 'Textiles & Apparel' },
      { key: 'MF053', value: 'Tires & Rubber' },
      { key: 'MF054', value: 'Tobacco' },
      { key: 'MF055', value: 'Wine, Beer and Spirits' },
      { key: 'MF056', value: 'Health & Nutrition Products' },
      { key: 'MF057', value: 'Personal Computers & Peripherals' },
    ],
  },
  {
    key: 'MI',
    value: 'Media & Internet',
    children: [
      { key: 'MI000', value: 'Animation' },
      { key: 'MI001', value: 'Blogs' },
      { key: 'MI002', value: 'Broadcasting & Media' },
      { key: 'MI003', value: 'Ebook & Audiobooks' },
      { key: 'MI004', value: 'Ecommerce & Internet Retail' },
      { key: 'MI005', value: 'Film Video & Media Production & Services' },
      { key: 'MI006', value: 'Internet & Digital Media' },
      { key: 'MI007', value: 'Internet-related Services' },
      { key: 'MI008', value: 'Internet News & Publishing' },
      { key: 'MI009', value: 'Media & Internet - General' },
      { key: 'MI010', value: 'Music & Music Related Services' },
      { key: 'MI011', value: 'Newspapers & News Services' },
      { key: 'MI012', value: 'Public Relations & Communication' },
      { key: 'MI013', value: 'Publishing' },
      { key: 'MI014', value: 'Radio Stations' },
      { key: 'MI015', value: 'Search Engines & Internet Portals' },
      { key: 'MI016', value: 'Social Media' },
      { key: 'MI017', value: 'Television Stations' },
      { key: 'MI018', value: 'Writing & Editing' },
    ],
  },
  {
    key: 'MN',
    value: 'Metals & Mining',
    children: [
      { key: 'MN000', value: 'Metals & Mining - General' },
      { key: 'MN001', value: 'Mining' },
    ],
  },
  {
    key: 'RE',
    value: 'Real Estate',
    children: [
      { key: 'RE000', value: 'Commercial Real Estate' },
      { key: 'RE001', value: 'Consumer Goods Rental' },
      { key: 'RE002', value: 'Equipment Rental Services' },
      { key: 'RE003', value: 'Leasing Residential Real Estate' },
      { key: 'RE004', value: 'Real Estate - General' },
      { key: 'RE005', value: 'Real Estate Agents & Brokers' },
      {
        key: 'RE006',
        value: 'Real Estate & Equipment Rental Services',
      },
    ],
  },
  {
    key: 'RT',
    value: 'Research & Technology',
    children: [
      { key: 'RT000', value: 'Artificial Intelligence & Machine Learning' },
      { key: 'RT001', value: 'Climate Data & Analytics' },
      { key: 'RT002', value: 'Nanotechnology' },
      { key: 'RT003', value: 'Research & Technology - General' },
      { key: 'RT004', value: 'Robotics' },
      { key: 'RT005', value: 'Technology' },
      { key: 'RT006', value: 'Think Tanks' },
      { key: 'RT007', value: 'Cryptocurrency' },
      { key: 'RT008', value: 'Mobile' },
      { key: 'RT009', value: 'Research - General' },
      { key: 'RT010', value: 'Think Tanks' },
    ],
  },
  {
    key: 'RL',
    value: 'Retail',
    children: [
      { key: 'RL001', value: 'Apparel & Accessories Retail' },
      { key: 'RL002', value: 'Consumer Electronics & Computers Retail' },
      {
        key: 'RL003',
        value: 'Department Stores Shopping Centers & Superstores',
      },
      { key: 'RL004', value: 'Eyewear' },
      { key: 'RL005', value: 'Flowers Gifts & Specialty' },
      { key: 'RL006', value: 'Footwear' },
      { key: 'RL007', value: 'Gas Stations Convenience & Liquor Stores' },
      { key: 'RL008', value: 'Grocery & Supermarkets' },
      { key: 'RL010', value: 'Home Improvement & Hardware' },
      { key: 'RL011', value: 'Jewelry & Watch Retail' },
      { key: 'RL012', value: 'Luxury Goods & Jewelry' },
      { key: 'RL014', value: 'Pet Products' },
      { key: 'RL015', value: 'Record, Video & Book Stores' },
      {
        key: 'RL016',
        value:
          'Rental - Other - Furniture A/V Construction & Industrial Equipment',
      },
      { key: 'RL017', value: 'Rental - Video & DVD' },
      { key: 'RL018', value: 'Retail - General' },
      { key: 'RL019', value: 'Retail Motor Vehicles' },
      { key: 'RL020', value: 'Retail Musical Instruments' },
      { key: 'RL021', value: 'Sporting & Recreational Equipment' },
      { key: 'RL023', value: 'Toys & Games' },
      { key: 'RL024', value: 'Wire & Cable' },
    ],
  },
  {
    key: 'SW',
    value: 'IT & Software',
    children: [
      { key: 'SW001', value: 'Business Intelligence Software' },
      { key: 'SW002', value: 'Cloud Software' },
      { key: 'SW003', value: 'Computer Games' },
      { key: 'SW004', value: 'Content & Collaboration Software' },
      {
        key: 'SW006',
        value: 'Customer Relationship Management Software (CRM)',
      },
      { key: 'SW007', value: 'Database & File Management Software' },
      { key: 'SW008', value: 'Desktop Computing Software Products' },
      { key: 'SW09', value: 'Embedded Software Products' },
      { key: 'SW010', value: 'Enterprise Resource Planning Software (ERP)' },
      { key: 'SW012', value: 'Mobile' },
      { key: 'SW013', value: 'Mobile Computing Software Products' },
      { key: 'SW014', value: 'Software & Technical Consulting' },
      { key: 'SW015', value: 'Data Infrastructure & Analytics' },
      { key: 'SW016', value: 'IT Systems & Services' },
      { key: 'SW017', value: 'Network Security Hardware & Software' },
      { key: 'SW018', value: 'Software Engineering' },
      { key: 'SW019', value: 'Software - General' },
    ],
  },
  {
    key: 'TC',
    value: 'Telecommunications',
    children: [
      { key: 'TC000', value: 'Cable & Satellite' },
      { key: 'TC001', value: 'Telecommunications - General' },
      { key: 'TC002', value: 'Wireless' },
    ],
  },
  {
    key: 'TP',
    value: 'Transportation',
    children: [
      { key: 'TP000', value: 'Airlines & Aviation' },
      { key: 'TP001', value: 'Delivery' },
      { key: 'TP002', value: 'Freight & Logistics Services' },
      { key: 'TP003', value: 'Rail Bus & Taxi' },
      { key: 'TP004', value: 'Ground Passenger Transportation' },
      { key: 'TP005', value: 'Rail Transportation' },
      { key: 'TP006', value: 'School & Employee Bus Services' },
      {
        key: 'TP006',
        value: 'Shuttle & Special Needs Transportation Services',
      },
      { key: 'TP007', value: 'Sightseeing Transportation' },
      { key: 'TP008', value: 'Taxi & Limousine Services' },
      { key: 'TP009', value: 'Transportation - General' },
      { key: 'TP010', value: 'Trucking Moving & Storage' },
      { key: 'TP011', value: 'Urban Transit Services' },
    ],
  },
];

export const CONTACT_METHOD_DATA = [
  { key: 'Work Email', value: 'Work Email' },
  { key: 'Personal Email', value: 'Personal Email' },
  { key: 'Mobile', value: 'Mobile' },
  { key: 'Phone', value: 'Phone' },
];

export const MAJOR_DATA = [
  { key: 'Computer Science', value: 'Computer Science' },
  { key: 'Business Administration', value: 'Business Administration' },
  { key: 'Management', value: 'Management' },
  { key: 'Accounting', value: 'Accounting' },
  { key: 'Marketing', value: 'Marketing' },
];

export const DEGREE_DATA = [
  { key: 'Bachelors', value: 'Bachelors' },
  { key: 'Masters', value: 'Masters' },
  { key: 'Associates', value: 'Associates' },
  { key: 'Doctorates', value: 'Doctorates' },
  { key: 'High School', value: 'High School' },
];

export const MANAGEMENT_LEVELS_DATA = [
  { key: 'Founder/Owner', value: 'Founder/Owner' },
  { key: 'C-Level', value: 'C-Level' },
  { key: 'Vice President', value: 'Vice President' },
  { key: 'Head', value: 'Head' },
  { key: 'Director', value: 'Director' },
  { key: 'Manager', value: 'Manager' },
  { key: 'Senior', value: 'Senior' },
  {
    key: 'Individual Contributor',
    value: 'Individual Contributor',
  },
  { key: 'Entry', value: 'Entry' },
  { key: 'Intern', value: 'Intern' },
  { key: 'Volunteer', value: 'Volunteer' },
];

export const REVENUE_DATA = [
  { key: 'select', label: 'Select' },
  { key: '<10000000', label: '< $10M' },
  { key: '10000000-50000000', label: '$10M - $50M' },
  { key: '50000000-100000000', label: '$50M - $100M' },
  { key: '100000000-500000000', label: '$100M - $500M' },
  { key: '500000000-1000000000', label: '$500M - $1B' },
  { key: '1000000000-5000000000', label: '$1B - $5B' },
  { key: '5000000000<', label: '$5B+' },
  { key: 'custom', label: 'Custom' },
];

export const YEARS_OF_EXPERIENCE_DATA = [
  { key: 'select', label: 'Select' },
  { key: '0-3', label: '0 - 3' },
  { key: '3-10', label: '3 - 10' },
  { key: '10<', label: '10 +' },
  { key: 'custom', label: 'Custom' },
];

export const EMPLOYEE_COUNT_DATA = [
  { key: 'select', label: 'Select' },
  { key: '1-10', label: '1 - 10' },
  { key: '11-50', label: '11 - 50' },
  { key: '51-100', label: '51 - 100' },
  { key: '101-500', label: '101 - 500' },
  { key: '501-1000', label: '501 - 1,000' },
  { key: '1001-5000', label: '1,001 - 5,000' },
  { key: '5001-10000', label: '5,001 - 10,000' },
  { key: '10001-25000', label: '10,001 - 25,000' },
  { key: '25001<', label: '25,001 +' },
  { key: 'custom', label: 'Custom' },
];

export const CHANGE_JOB_DATA = [
  { key: 'select', label: 'Select' },
  { key: '0-90', label: 'Last 3 Months' },
  { key: '0-180', label: 'Last 6 Months' },
  { key: '0-360', label: 'Last Year' },
  { key: '0-720', label: 'Last 2 Years' },
  { key: '0-1080', label: 'Last 3 Years' },
];
